export default function restaurantIsFreeForModule(restaurant, moduleType) {
    const subscriptions = restaurant?.subscriptions?.data;

    return Array.isArray(subscriptions) && !subscriptions.some((subscription) => subscription.module?.type === moduleType);
}
